// Tags KDS colour tokens before any KDS module evaluates — keep it first.
import './theme/bootstrap';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { ConfigProvider, NotificationsPanel } from '@decisiv/ui-components';
import './theme/tokens.css';
import './index.css';
import { Link } from 'react-router-dom';
import App from './App';
import './setup/kdsPropTypesPatch';
import getEnvironment from './utils/getCurrentEnv';
import resolveEnvTheme from './utils/envTheme';
import ThemeProvider from './theme/ThemeProvider';

// On QA/Staging the EnvFrame label tab overlays the top edge at max z-index;
// offset the notifications panel below it so "Dismiss All" isn't covered.
const envTheme = resolveEnvTheme(
  getEnvironment(process.env.REACT_APP_BASE_URL),
);

createRoot(document.getElementById('root')).render(
  <ThemeProvider>
    <ConfigProvider linkRenderer={Link}>
      {/* 2.5 spacing units = 25px, clearing the 22px-tall EnvFrame label */}
      <NotificationsPanel marginTop={envTheme ? 2.5 : 0} zIndex={1000} />
      <App />
    </ConfigProvider>
  </ThemeProvider>,
);
